import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }

import { TicketModule } from "@/store/modules/Ticket";
import { computed, onMounted, ref, watch } from "vue";
import { socket } from "@/main";
import { AuthModule } from "@/store/modules/Auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const value = ref(0);
const colors = ref(["#99A9BF", "#F7BA2A", "#FF9900"]);
const ticket = computed(() => TicketModule.currentTicket);

async function onChange(score: number) {
	if (value.value !== score)
		socket.emit("TICKET_RATE", {
			token: AuthModule.token,
			ticketId: TicketModule.currentRoomID,
			score,
		});
}

watch(
	() => ticket.value?.rate.score,
	current => {
		console.log("rate score", current);
		if (current) value.value = current;
	}
);

onMounted(() => {
	if (ticket.value) value.value = ticket.value.rate?.score;
});

return (_ctx: any,_cache: any) => {
  const _component_el_rate = _resolveComponent("el-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_rate, {
      "model-value": value.value,
      size: "large",
      colors: colors.value,
      onChange: onChange
    }, null, 8, ["model-value", "colors"])
  ]))
}
}

})